import { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "swn-consent-v1";
const ConsentContext = createContext(null);

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(readStored);

  const persist = useCallback((value) => {
    const next = { ...value, ts: new Date().toISOString() };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* Speicher nicht verfügbar */
    }
    setConsent(next);
  }, []);

  const acceptNecessary = useCallback(
    () => persist({ necessary: true, externalMedia: false }),
    [persist],
  );
  const acceptExternalMedia = useCallback(
    () => persist({ necessary: true, externalMedia: true }),
    [persist],
  );
  const resetConsent = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    setConsent(null);
  }, []);

  const value = useMemo(
    () => ({ consent, acceptNecessary, acceptExternalMedia, resetConsent }),
    [consent, acceptNecessary, acceptExternalMedia, resetConsent],
  );
  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

export function useConsent() {
  return useContext(ConsentContext);
}
